import React, { useState, useRef, useEffect, useCallback } from "react";
import HeaderWrapper from "./Header.style";
import { Button } from "primereact/button";
import RightSidebar from "../Sitebar/SiteBar";
import infoIcon from "../../assets/images/info-icon.svg";
import flashIcon from "../../assets/images/flash-icon.svg";
import HelpYou from "../HelpYou/Help";
import LanguageSwitcher from "../LanguageSwitcher";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";


const Header = ({ hideContent,applicationName }) => {  
  const { businessLine } = useParams()
  const { i18n, t } = useTranslation();

  const currentLanguageCode = i18n.language || "en";
  const showRTL = currentLanguageCode === "ar";

  const [visibleRight, setVisibleRight] = useState(false);
  const [visibleHelp, _setVisibleHelp] = useState(false);
  const [isClickingFlash, updateClickingFlash] = useState(false);

  const flashModalRef = useRef();
  const visibleHelpRef = useRef(visibleHelp);

  const setVisibleHelp = useCallback(
    (data) => {
      if (isClickingFlash) return;
      visibleHelpRef.current = data;
      _setVisibleHelp(data);
    },
    [_setVisibleHelp, isClickingFlash]
  );

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        visibleHelpRef.current &&
        flashModalRef.current &&
        !flashModalRef.current.contains(e.target) &&
        !e.target?.classList?.contains("white-box")
      ) {
        updateClickingFlash(true);
        setVisibleHelp(false);
        setTimeout(() => updateClickingFlash(false), 100);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setVisibleHelp]);


  return (
    <HeaderWrapper>
      {!hideContent ? (
        <>
          <div className="main-div pt-5 pb-4 px-4 my-3">
            <div className="row">
              <div className="col-12 layout-direction">
                <div className="blank-box" aria-label="add" />

                <div>
                  <LanguageSwitcher />
                </div>

                <div
                  className={"white-box " + (showRTL ? "ml-15" : "")}
                  aria-label="add"
                  onClick={(e) => {
                    e.preventDefault();
                    setTimeout(() => setVisibleHelp(!visibleHelp), 10);
                  }}
                >
                  <div className="success-icon"></div>
                  <img src={flashIcon} alt="Flash Icon" />
                </div>

                <Button
                  className={businessLine ? `help-button help-button-${businessLine}` : 'help-button'}
                  onClick={() => setVisibleRight(true)}
                >
                  <img src={infoIcon} alt="Info Icon" />
                  <span className="px-2">{i18n.t("RIGHTHEADER.NEEDHELP")}</span>
                </Button>

              </div>
            </div>
          </div>
          <RightSidebar
            visibleRight={visibleRight}
            onClick={() => setVisibleRight(false)}
            applicationName={applicationName}
          />
          <HelpYou visibleHelp={visibleHelp} ref={flashModalRef} />
        </>
      ) : (
        <div>
          <LanguageSwitcher />
        </div>
      )}
    </HeaderWrapper>
  );
};

export default Header;
